<template>
  <div class="detial-icongroup">
    <div class="group pl-1">
      <span>
        <a class="tuite" @click="share_twitter" target="_blank"></a>
      </span>

      <span>
        <a class="facebook" target="_blank" @click="shareFacebook"></a>
      </span>
      <span class="bg-wx">
        <a class="wx" @click="showWx"></a>
      </span>
      <span>
        <a class="sina" target="_blank" @click="shareSina"></a>
      </span>
    </div>
  </div>
</template>

<script>
import { setShareHtml, getShortUrl } from "@/network/details.js";

import { setNewShare } from "@/network/share.js";

export default {
  name: "DetialIconGroup",
  props: ["featureInfo"],
  data() {
    return {
      istrue: false,
      num: 0,
      share_title: "",
      share_url: "",
      shareBoxLeft: 0,
      clientWidth: 0,
      tempImgUrl: "",
    };
  },
  mounted() {
    this.clientWidth =
      document.documentElement.clientWidth || document.body.clientWidth;
    this.share_title = this.featureInfo.featureName;
    this.share_url = window.location.href;
    this.setPosition();
    this.shareBoxLeft = (document.body.clientWidth - 600) / 2;
  },
  methods: {
    handelImg() {
      if (this.featureInfo.featureImgUrl) {
        var pointlength = this.featureInfo.featureImgUrl.lastIndexOf(".");
        var alllength = this.featureInfo.featureImgUrl.length;
        var str1 = this.featureInfo.featureImgUrl.substr(0, pointlength);
        var str2 = this.featureInfo.featureImgUrl.substr(
          pointlength,
          alllength
        );
        var newStr;
        newStr = str1 + "_related" + str2;
        this.tempImgUrl = newStr;
      }
    },

    showWx() {
      this.$emit("showWxFn");
    },
    shareFacebook() {
      this.handelImg();
      let postId = this.featureInfo.featureId;
      setShareHtml({
        id: postId,
        website: "facebook",
      }).then((res) => {
        console.log(res.data);
        var _uri = res.data;
        if (this.clientWidth > 750) {
          window.open(
            _uri,
            "",
            "width=600, height=500, left=" + this.shareBoxLeft + ", top=150"
          );
        } else {
          location.href = _uri;
        }
      });
    },
    share_twitter() {
      this.handelImg();
      let postId = this.featureInfo.featureId;
      setShareHtml({
        id: postId,
        website: "twitter",
      }).then((res2) => {
        let twitterUrl = res2.data;
        if (this.clientWidth > 750) {
          window.open(
            twitterUrl,
            "",
            "width=600, height=500, left=" + this.shareBoxLeft + ", top=150"
          );
        } else {
          location.href = twitterUrl;
        }
      });
    },
    shareSina() {
      let sinaUrl =
        "http://service.weibo.com/share/share.php?appkey=&title=" +
        encodeURIComponent(this.featureInfo.featureName) +
        "&url=" +
        this.share_url;
      window.open(
        sinaUrl,
        "",
        "width=600,height=500,scrollbars=1,left=" +
          this.shareBoxLeft +
          ", top=150"
      );
    },

    setPosition() {
      // console.log( document.body.clientWidth)
      this.shareBoxLeft = (document.body.clientWidth - 600) / 2;
      // alert(this.shareBoxLeft)
    },
    assist() {
      if (this.istrue == true) {
        this.istrue = !this.istrue;
        this.num--;
      } else {
        this.istrue = !this.istrue;
        this.num++;
      }
    },
  },
};
</script>

<style lang="less" scoped>
.detial-icongroup {
  height: 0.5rem;
  line-height: 0.5rem;
  a {
    float: left;
    height: 0.45rem;
    width: 0.45rem;
    margin: 0.4rem 0.1rem 0.1rem 0.1rem;
    cursor: pointer;
  }

  .facebook {
    background: url("~@/assets/imgs/detial/facebook.png") no-repeat;
    background-size: 100% 100%;
  }
  .tuite {
    background: url("~@/assets/imgs/detial/tuite.png") no-repeat;
    background-size: 100% 100%;
  }
  .sina {
    background: url("~@/assets/imgs/detial/sina.png") no-repeat;
    background-size: 100% 100%;
  }
  .wx {
    background: url("~@/assets/imgs/detial/weixin.png") no-repeat;
    background-size: 100% 100%;
  }
}
@media screen and (min-width: 768px) {
  .detial-icongroup {
    padding: 0;
    a {
      width: 0.36rem;
      height: 0.36rem;
    }
  }
}
</style>
